<template>
  <el-popover placement="bottom"
              width="460"
              trigger="click" name="popovercomponent" @show="loadMore_" v-loading.fullscreen="bodyLoading">
    <div id="index_top_notice">
    <el-tabs v-model="activeName" :stretch="true" @tab-click="changeNoticeType">
      <el-tab-pane

                    :label="timeoutNoticeUnreadTotal==0?'超时通知':timeoutNoticeUnreadTotal<=99?'超时通知('+ timeoutNoticeUnreadTotal+')':'超时通知(99+)'"
                    name="first"></el-tab-pane>
      <el-tab-pane
                    :label="auditNoticeUnreadTotal==0?'审核通知':auditNoticeUnreadTotal<=99?'审核通知('+ auditNoticeUnreadTotal+')':'审核通知(99+)'"

                    name="second"></el-tab-pane>
      <el-tab-pane
                   :label="taskNoticeUnreadTotal==0?'任务通知':taskNoticeUnreadTotal<=99?'任务通知('+ taskNoticeUnreadTotal+')':'任务通知(99+)'"

                   name="third"></el-tab-pane>
      <el-tab-pane
                    :label="otherNoticeUnreadTotal==0?'其他通知':otherNoticeUnreadTotal<=99?'其他通知('+ otherNoticeUnreadTotal+')':'其他通知(99+)'"

                    name="ninety-nine"></el-tab-pane>
    </el-tabs>
    </div>
    <avue-empty
      v-if="data.length==0"
      desc="你已查看所有通知"
      style="margin:88px 0;"
    ></avue-empty>
    <!-- <div v-if="data.length==0" style="height:300px;text-align:center;" v-loading="loading">
      暂无消息
    </div> -->
    <el-scrollbar style="height:300px" v-if="data.length>0" v-loading="loading">
      <!-- <avue-notice :data="data"
                    ref="notice"
                   :option="option"
                   @page-change="pageChange"></avue-notice> -->

      <div class="avue-notice__item"
      :item="JSON.stringify(item)"
        v-for="(item,index) in data"
                  :key="index"

      >
        <div class="avue-notice__img">
          <img src="/img/bg/vip2.png" alt="">
        </div>
        <div class="avue-notice__content">
          <div class="avue-notice__title notifyTitle" @click="updateMeassageStatus(item)">
            <div>
              <!-- <span class="avue-notice__name textOVerThree">{{item.notifyTitle}}</span> -->

              <div v-for="(item,index) in JSON.parse(item.businessInfo)" :key="item" class="avue-notice__name textOVerThree">

                <span v-if="!fields.includes(index)">{{index=='notifyTitle'?item: index + ':' + item}}  </span>
              </div>
              <!-- <span class="avue-notice__name textOVerThree">{{businessInfo(item.businessInfo)}}</span> -->
              <div class="avue-notice__subtitle" style="">{{item.notifyTime}}</div>
            </div>
            <div class="notice_status_tag_box">
                <span class="avue-notice__tag">
                  <span class="el-tag el-tag--small el-tag--read el-tag--light" v-if="item.readFlag">已读</span>
                  <span class="el-tag el-tag--small el-tag--danger el-tag--light" v-else>未读</span>
                </span>
                <span class="avue-notice__tag" >
                  <span
                    class="el-tag el-tag--small el-tag-view el-tag--light"
                    v-show="messageSubType!=99"
                    @click="toDetail(item)"
                   >查看</span>
                  <!-- <el-button  class="button-new-tag " size="small" @click="showInput">查看</el-button> -->
                </span>
            </div>

          </div>

        </div>
      </div>

    <div v-loading="loading" @click="loadMore" id="loadMore" style="text-align:center;padding:1rem 0;cursor:pointer;">加载更多</div>

    </el-scrollbar>
    <div slot="reference">
      <el-badge :value="page.total>0?page.total:''">
        <i class="el-icon-bell"></i>
      </el-badge>
    </div>
    <el-divider></el-divider>
    <div class="button">
      <el-button @click="readingAllMeassage">全部已读</el-button>
      <el-button @click="jumpNoticeCenter">查看更多</el-button>
    </div>
  </el-popover>
</template>

<script>
import {
  getMessageList,
  getMessageDetail,
  updateBatchStatus,
  messageDialogSum,
  getAllMessageTypeSum,
  updateMeassageStatus
  } from "@/api/message/message";
import {mapGetters} from "vuex";

export default {
  name: "top-notice",
  props: ['extendMessage'],
  data () {
    return {
      bodyLoading:false,
      activeName: 'first',
      page:{
        pages:0,
        size:10,
        current:1,
        total:0,
      },
      timeoutNoticeUnreadTotal:0,//超时 通知类型未读总数量
      auditNoticeUnreadTotal:0,//审核 通知类型未读总数量
      taskNoticeUnreadTotal:0,//任务 通知类型未读总数量
      otherNoticeUnreadTotal:0,//其他 通知类型未读总数量
      messageSubType:1,//消息类型
      option: {
        props: {
          img: 'img',
          title: 'notifyTitle',
          subtitle: 'notifyTime',
          tag: 'tag',
          status: 'messageType'
        },
      },
      // data: list,
      data: [],
      loading:false,
      fields:['notifyUrlParam','result','name','companyName'],
    }
  },
  watch:{
    extendMessage(val){
      console.log(val);
      // if(val){
        setTimeout(()=>{

          document.querySelector('i[class="el-icon-bell"]').click();
        })
      // }
    },
  },
  created () {
    getMessageList({
      userId:this.userInfo.user_id,
      size:this.page.size,
      current:this.page.current,
      messageSubType: this.messageSubType

    }).then((res)=>{
      this.data = res.data.data.records;
      this.handleDataList(this.data);
      this.getUnreadMessageDialogSum();
      // this.page.total = res.data.data.total;
      //判断是否显示 '加载更多' 当返回的数量不足10的时候 表示没有更多了
      if(res.data.data.records.length<10){
        this.page.noMoreFlag = true;
        setTimeout(()=>{
          if(document.querySelector('div[id="loadMore"]')){
            document.querySelector('div[id="loadMore"]').style.display = "none";
          }
        })
      }else{
        this.page.current = this.page.current+1;
      }
    });
    this.getAllMessageTypeSum()
  },
  computed: {
    //获取用户信息;
      ...mapGetters(["userInfo"])
  },
  methods: {
    // 处理消息体，使其成为一句话
    businessInfo(item){
      let temObj = JSON.parse(item);
      let str = '';
      for(var key in temObj){
        if(key!='notifyTitle'){
          str += key +":"+temObj[key]+' \t'
        }
        console.log(key)
      }


      return str;
    },
    // 跳转到奥消息中心页面
    jumpNoticeCenter(){
      this.$router.push('/crmedical/notice/messagecenter');
      document.querySelector('i[class="el-icon-bell"]').click();
      // this.
    },
    // 改变消息未读状态
    updateMeassageStatus(item){
      if(item.readFlag==1){ //当状态为1 已读的时候 直接return
        return;
      }
      updateMeassageStatus({notifyUserId:item.notifyUserId}).then(res=>{
        item.readFlag = 1;
        this.getAllMessageTypeSum();
        this.getUnreadMessageDialogSum();
        // this.loadMore_();
      })
    },
    // 获取各个类型的消息通知未读数量
    getAllMessageTypeSum(){
      getAllMessageTypeSum().then(res=>{
        this.timeoutNoticeUnreadTotal = res.data.data.timeoutNoticeUnreadTotal;//超时 通知类型未读总数量
        this.auditNoticeUnreadTotal = res.data.data.auditNoticeUnreadTotal;//审核 通知类型未读总数量
        this.taskNoticeUnreadTotal = res.data.data.taskNoticeUnreadTotal;//任务 通知类型未读总数量
        this.otherNoticeUnreadTotal = res.data.data.otherNoticeUnreadTotal;//其他 通知类型未读总数量
      })
    },
    // 查询未读数量
    getUnreadMessageDialogSum(){
      messageDialogSum().then(res=>{
        this.page.total = res.data.data;

      })
    },
    // 全部已读
    readingAllMeassage(){
      updateBatchStatus({messageSubType: this.messageSubType}).then(res=>{

        this.getAllMessageTypeSum();
        this.loadMore_();
      })
    },
    // 切换页签
    changeNoticeType(type){
      console.log(type)
      this.page.current = 1;
      this.data = [];
      // 根据标签请求不同类型的通知
      if(type.name == 'first'){
        this.messageSubType = 1;
      }else if(type.name == 'second'){
        this.messageSubType = 2;
      }else if(type.name == 'third'){
        this.messageSubType = 3;
      }else if(type.name == 'ninety-nine'){
        this.messageSubType = 99;
      }
      this.loadMore();
    },
    //跳转到相关页面
    toDetail(item){
      this.bodyLoading = true;
      console.log(item);
      this.getUnreadMessageDialogSum();//更新小铃铛数字
      getMessageDetail({
        messageType:item.messageType,
        messageRemark:item.messageRemark,
        readFlag:item.readFlag,
        id:item.id,
        notifyUserId: item.notifyUserId,
        notifyId: item.notifyId
        }).then((res)=>{
        console.log(JSON.stringify(res.data.data));

          if(JSON.stringify(res.data.data)==="{}"){
            this.loadMore();
            this.$message.error(res.data.msg);
            setTimeout(()=>{

                this.bodyLoading = false;
                document.querySelector('i[class="el-icon-bell"]').click();
            });
          }else{

            let toUrl = res.data.data.split('?')[0];

            if(document.querySelector(`div[id*="${toUrl}"]`)){
            document.querySelector(`div[id*="${toUrl}"]`).querySelector('span[class="el-icon-close"]').click();

            }
            this.$router.push({ path: '/wel/index' });
            setTimeout(()=>{
              this.$router.push({ path: res.data.data });
              setTimeout(()=>{
                this.bodyLoading = false;
                document.querySelector('i[class="el-icon-bell"]').click();
              },500)
            })
            console.log(this.socketMessage);
          }
        // }
      });
    },
    // 根据已读未读状态显示已读未读
    handleDataList(list){
      list.forEach((element,index) => {
        if(element.readFlag){
          element.tag = '已读';
        }else{
          element.tag = '未读';
        }
        element.img = '/img/bg/vip2.png';
        this.data[index] = element
      });
    },
    // 获取列表
    loadMore_(){
      this.page.current = 1;
      // this.messageSubType = 1;
      // this.activeName = 'first';
      this.loading = true;
      this.getUnreadMessageDialogSum();
      this.getAllMessageTypeSum();
        getMessageList({
          userId:this.userInfo.user_id,
          size:this.page.size,
          current:this.page.current,
          messageSubType: this.messageSubType
        }).then((res)=>{
          console.log(res.data.data.records);
          res.data.data.records.forEach(ele=>{ //当消息为未读时 才有这个属性 为了方便后面将该消息往下排
            if(ele.readFlag==0){
              ele.readable = true;
            }
          })
          this.data = res.data.data.records;
          this.handleDataList(this.data);
          // this.page.total = res.data.data.total;
          if(res.data.data.records.length<10){
            this.page.noMoreFlag = true;
            setTimeout(()=>{
              if(document.querySelector('div[id="loadMore"]')){
                document.querySelector('div[id="loadMore"]').style.display="none";
              }
            });
          }else{
            this.page.noMoreFlag = false;
            console.log('loadMore');
            setTimeout(()=>{
              if(document.querySelector('div[id="loadMore"]')){
                document.querySelector('div[id="loadMore"]').style.display="block";
              }
            });
            this.page.current = this.page.current+1;
          }
          this.loading = false;
        });
    },
    //加载更多消息
    loadMore(){
      // 1.去掉列表中已读消息 然后通过接口查询会将已读消息重新排列在已读中
      // let data = this.data.filter(ele=>{
      //   if((ele.readFlag==0 && ele.readable) || (ele.readFlag==1 && !ele.readable)){
      //     return ele;
      //   }
      // })

      // this.data = data;
      // this.getUnreadMessageDialogSum();
      console.log("this.page.current",this.page.current);
      this.loading = true;
        getMessageList({
          userId:this.userInfo.user_id,
          size:this.page.size,
          current:this.page.current,
          messageSubType: this.messageSubType
        }).then((res)=>{
          console.log(res.data.data.records);
          res.data.data.records.forEach(ele=>{ //当消息为未读时 才有这个属性 为了方便后面将该消息往下排
            if(ele.readFlag==0){
              ele.readable = true;
            }
          })
          this.data = this.data.concat(res.data.data.records);
          this.handleDataList(this.data);
          // this.page.total = res.data.data.total;
          if(res.data.data.records.length<10){
            this.page.noMoreFlag = true;
            setTimeout(()=>{
              if(document.querySelector('div[id="loadMore"]')){
                document.querySelector('div[id="loadMore"]').style.display="none";
              }
            });
          }else{
            setTimeout(()=>{
              if(document.querySelector('div[id="loadMore"]')){
                document.querySelector('div[id="loadMore"]').style.display="block";
              }
            });
            this.page.current = this.page.current+1;
          }
          this.loading = false;
        });
    },

  }
};
</script>

<style lang="scss" scoped>
.button{
  display: flex;
  justify-content: space-around;
}
.notifyTitle{
  display: flex;
  margin: 0 10px;
  justify-content: space-between;
  font-size: 14px;
}
.textOVerThree {
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical
}
.notice_status_tag_box{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.el-tag--read{
  background-color: #eee;
  color: #333;
}
</style>
<style >
#index_top_notice{
  width: 100%;
}
#index_top_notice .el-tabs__item{
  padding: 0 5px;
}
</style>